/**
 * Bounded-concurrency map. Extracted from the semaphore pattern in
 * scripts/ai/upload-thumbnails-to-r2.js (the repo's canonical pool).
 *
 * Results are INDEX-ADDRESSED: results[i] always corresponds to items[i],
 * regardless of completion order — callers relying on input order (index
 * arrays, catalogs) stay deterministic. fn errors reject the whole map;
 * catch inside fn to tolerate per-item failures.
 */
export async function mapWithConcurrency(items, limit, fn) {
  const results = new Array(items.length);
  let next = 0;
  const workerCount = Math.max(1, Math.min(limit, items.length));
  const workers = Array.from({ length: workerCount }, async () => {
    while (next < items.length) {
      const i = next++;
      results[i] = await fn(items[i], i);
    }
  });
  await Promise.all(workers);
  return results;
}
